module.exports = __webpack_public_path__ + "img/173.amount_of_the_food.68331d50.svg";